import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { downloadFile } from 'helper';
import { exportPartnerRatingByRealEstateExcelReport } from '../api';

export function useExportPartnerRatingByRealEstateExcelReport() {
  const [loading, setLoading] = useState(false);

  const { addError } = useError();

  const exportExcelReport = async (config?: AxiosRequestConfig) => {
    setLoading(true);

    try {
      downloadFile(
        await exportPartnerRatingByRealEstateExcelReport(config),
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Отчет по дому.xlsx',
      );
    } catch (error) {
      addError((error as AxiosError).response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, exportExcelReport };
}
